import { useEffect } from 'react';

export const useLoaded = (props = {}, loadings = []) => {
  const { onLoaded } = props;
  useEffect(() => {
    const has = loadings.find((l) => !!l);
    if (!has) {
      onLoaded && onLoaded();
    }
  }, loadings);
};
